/** Acciones del conjunto efectivo de capacidades. */
export class LoadCapabilities {
  static readonly type = '[Capabilities] Load';
  constructor(public readonly projectId: string) {}
}

/**
 * Vuelve a pedir el conjunto.
 *
 * `reason` no es decorativo: distingue el refresco rutinario del que dispara un 403, y ese segundo
 * caso es el que interesa en los registros — significa que la interfaz y el backend habían dejado
 * de estar de acuerdo.
 */
export class RefreshCapabilities {
  static readonly type = '[Capabilities] Refresh';
  constructor(public readonly reason: 'project-change' | 'forbidden' | 'manual' = 'manual') {}
}

/** El punto de decisión no está disponible. No es lo mismo que no tener permiso. */
export class CapabilitiesUnavailable {
  static readonly type = '[Capabilities] Unavailable';
}
